// extracted by mini-css-extract-plugin
export default {"img":"image__img___2IBAM","img--loaded":"image__img--loaded___2oRhq"};